import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EnvironmentService } from '@cvs/services';
import { map, Observable, ReplaySubject, tap } from 'rxjs';
import { User } from 'src/app/core/user/user.types';

@Injectable({
    providedIn: 'root'
})
export class UserService {
    private _user: ReplaySubject<User> = new ReplaySubject<User>(1);
    private readonly endpoint: string;
    /**
     * Constructor
     */
    constructor(
        private _httpClient: HttpClient,
        private environmentService: EnvironmentService
    ) {
        this.endpoint = this.environmentService.getEnvironment().authConfig.userinfoEndpoint;
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Setter & getter for user
     *
     * @param value
     */
    set user(value: User) {
        // Store the value
        this._user.next(value);
    }

    get user$(): Observable<User> {
        return this._user.asObservable();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Get the current logged in user data
     */
    get(): Observable<User> {
        return this._httpClient.get<User>(this.endpoint).pipe(
            tap((user) => {
                this._user.next(user);
            })
        );
    }

    /**
     * Update the user
     *
     * @param user
     */
    update(user: User): Observable<any> {
        return this._httpClient.patch<User>(this.endpoint, { user }).pipe(
            map((response) => {
                this._user.next(response);
            })
        );
    }

    getUser(user: any) {
        this._user.next(user);
    }
}
